import React from 'react';
import PropTypes from 'prop-types';

const UiReorderPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    />
  );
};

UiReorderPath.propTypes = {
  fill: PropTypes.string,
};

export default UiReorderPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-reorder.jsx